module.exports = __webpack_public_path__ + "1a07ed96f05bfb34db3d1db99bb788f6.svg";